import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import BookActionComponent from '@Components/publication/book-action/book-action.component';
import { ArmyBookAction } from '@Redux/actions';
import ArmyBookMakeForm from '@Components/publication/army/make/army-book-make.form.component';
import ArmyBookNewForm from '@Components/publication/army/new/army-book-new.form.component';
import { ArmyBookMapper } from '@Mapper/publication/army-book.mapper';
import { ArmyBookImportParams } from '@Components/publication/army/new/army-book.validate';
import armyBookSlice from '@Redux/reducers/publication/army-book.slice';
import toast from 'react-hot-toast';
import { ArmyBookActionState } from '@Stores/publication/army-book.state';
import ArmyBookPrintComponent from '@Components/publication/army/print/army-book-print.component';

const PublicationArmyBookPageNew: React.FC<Props> = ({
  book,
  onImport,
  actions,
}) => {
  const currentLocale = document.documentElement.lang;

  const onSubmit = (values: any) => {};

  return (
    <>
      <BookActionComponent />

      <Breadcrumb tag="nav">
        <BreadcrumbItem tag="a" href={`/${currentLocale}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </BreadcrumbItem>
        <BreadcrumbItem tag="a" href={`/${currentLocale}/publication/books`}>
          Publications Armies
        </BreadcrumbItem>
        <BreadcrumbItem tag="span" active>
          {book?.name || 'New army book'}
        </BreadcrumbItem>
      </Breadcrumb>

      {actions.make && (
        <>
          {!book && <ArmyBookNewForm onImport={onImport} />}
          {book && (
            <ArmyBookMakeForm
              army={book}
              disabled={false}
              onSubmit={onSubmit}
            />
          )}
        </>
      )}
      {actions.print && (
        <ArmyBookPrintComponent />
      )}
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  book: state.armyBook.entity,
  isLoading: state.armyBook.isLoading,
  actions: {
    make: !state.armyBook.action,
    print: state.armyBook.action === ArmyBookActionState.Print,
  },
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<ArmyBookAction>(
    TYPES.Actions.Publication.ArmyBookAction,
  );
  const armyBookMapper = container.get<ArmyBookMapper>(
    TYPES.Mapper.ArmyBookMapper,
  );

  return {
    load: (id: string) => dispatch(action.fetchData({ entityId: id })),
    onImport: (values: ArmyBookImportParams) => {
      try {
        const json = JSON.parse(values.data);
        const army = armyBookMapper.map(json);

        dispatch(armyBookSlice.actions.setMyArmyBook(army));
        toast.success('Army book imported successfully!');
      } catch (error: unknown) {
        console.log('Impossible parse data', error);
        toast.error(`Impossible to import the Army book: ${error}`);
      }
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublicationArmyBookPageNew);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
